import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { fontSize13 } from "./modal_children.module.scss";

import Accordian from "@/components/core/Accordian";
import { isMobile } from "@/helpers/utils";

const HMuchMoreModal = ({ benefitsArray }) => {
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    setMobileView(isMobile(window.innerWidth));
  }, []);

  return (
    <section className={!mobileView ? "vh75 verticalScroll" : ""}>
      <div
        className={classNames(
          "d-flex flex-column mx-4 mt-3 mt-md-0 color-secondary",
          fontSize13
        )}
      >
        <Accordian>
          {benefitsArray.length > 0 &&
            benefitsArray.map((benefit, index) => {
              return (
                <div label={benefit.title} key={index}>
                  <p>{benefit.description}</p>
                </div>
              );
            })}
        </Accordian>
      </div>
    </section>
  );
};
HMuchMoreModal.propTypes = {
  benefitsArray: PropTypes.array,
};

HMuchMoreModal.defaultProps = {
  benefitsArray: [],
};

export default HMuchMoreModal;
